<template>
  <v-container fluid>
    <v-layout
      v-if="loading"
      align-space-around
      justify-space-around
      column
      fill-height
    >
      <v-flex>
        <h3>{{ strings.loading }}...</h3>
      </v-flex>
      <v-flex>
        <v-progress-circular
          :size="50"
          color="secondary"
          indeterminate
        />
      </v-flex>
    </v-layout>
    <v-layout
      v-if="!loading && groupList.length >= 1"
      align-space-around
      justify-space-around
      column
      fill-height
    >
      <v-flex
        v-for="group in groupList"
        :key="group.id"
      >
        <GroupCard
          v-if="group.poiIds.length > 0"
          :group="group"
        />
      </v-flex>
    </v-layout>
    <v-layout
      v-if="!loading && groupList.length < 1"
      align-space-around
      justify-space-around
      column
      fill-height
    >
      <v-flex>
        <h3>{{ strings.noPointsofInteresttoshow }}</h3>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import GroupCard from "../components/GroupCard.vue";
import { getMessaging, onMessage, getToken } from "firebase/messaging";
import Notification from "../models/Notification";
import PermissionError from "../exceptions/PermissionError";
import { mapGetters } from "vuex";
export default {
  name: "Group",
  components: {
    GroupCard
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("login", ["userId", "technicianId", "selectedAccount"]),
    ...mapGetters("notifications", ["messageToken", "hasLoggedIn"]),
    ...mapGetters("group", ["groups", "loading"]),
    ...mapGetters("page", ["strings"]),
    groupList() {
      if(this.selectedAccount) {
        return this.groups.filter(l => l.account == this.selectedAccount.id);
      }
      else {
        return [];
      }
    },
  },
  mounted() {
    if (this.technicianId == null) {
      // try tecnicianID from cache
      const cachedUser = this.$ls.get("technicianId");
      if (cachedUser != null) {
        this.$store.commit("login/setTechnicianId", cachedUser);
      } else {
        this.$router.push({ name: "login" }).catch(() => {});
      }
    }
    this.getGroupData();
    this.$store.dispatch("group/GetAllGroups");
    this.$store.dispatch("group/GetRepairGroups");
  },
  created() {
    const messaging = getMessaging();
    
    if (!this.messageToken) {
      if(!this.hasLoggedIn) {
         getToken(messaging, {
           vapidKey: "BBsnnR-jT6HhLE8sdKtWq7dCikuZ6JHvTikDFJLQgSv1eLJFblMvE9zWqw22qmKoAQSo0QTFajIpKCR9CzE9IcA"
         })
         .then(currentToken => {
           this.$store.dispatch("notifications/saveNotificationToken", { 
              token: currentToken,
              vm: this
            });
         })
         .catch(error => {
           console.warn(error);
         })
      }
    }

    onMessage(messaging, (payload) => {
      // make model and send to store:
      let note = new Notification(payload.notification);
      this.$store.commit("notifications/addNotifications", note);

      if(note.poiId) {
        if(this.$route.name === "group") {
          setTimeout(async() => {
            await this.getGroupData();
            await this.$store.dispatch("poi/GetPoisByGroups", this.groupId);
            this.$store.commit("group/setActiveGroup", note.group);
            this.$store.commit("poi/setActiveGroupPoi", note.poiId);
            this.$router.push({ name: "dataDetail", params: { id: note.poiId } }).catch(() => {});
          }, 500) //need a timeout here, as if the app is in deep sleep, can take a sec to load, so will end up not routing
        }
      }
    });
  },
  methods: {
    async getGroupData() {
      await this.$store.dispatch("group/GetGroupsForTechnician");
      this.$store.dispatch("settings/getSetting");
    }
  }
};
</script>
